import React, { useCallback, useState } from "react";
import { RecentlyUsedDates } from "./recentlyUsedDates";
import { CurrentMonth } from "./currentMonth";
import { TimeRangePicker } from "./timeRangePicker";
import {
  Container,
  ContainerLeft,
  ContainerRight,
} from "./styles";
import { LOCAL_STORAGE_KEYS } from "../../witadmin/Common/constants";
import { formatDefaultDate, isAfterDates } from "../helpers/dates";

const MAX_RECENTLY_USED_DATES = 6;

interface TimeRangeProps {
  date: Date;
  onSubmit: (fromDate: Date) => void;
}

const getRecentlyUsedDatesList = (): string[] => {
  const recentlyUsedDates: string[] = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS.INVENTORY_MANAGEMENT_RECENTLY_USED_DATES) || "[]"
  ) || [];
  return recentlyUsedDates.filter(it => isAfterDates(it, new Date()));
};

const addToRecentlyUsedDates = (recentlyUsedDatesList: string[], date: Date): string[] => {
  const fromDate = formatDefaultDate(date);
  const result = [ ...recentlyUsedDatesList ];
  if (result.length === MAX_RECENTLY_USED_DATES) {
    result.pop();
  }
  result.unshift(fromDate);
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.INVENTORY_MANAGEMENT_RECENTLY_USED_DATES,
    JSON.stringify(result)
  );
  return result;
};

export const TimeRange = ({ date, onSubmit }: TimeRangeProps) => {
  const [recentlyUsedDates, setRecentlyUsedDates] = useState<string[]>(getRecentlyUsedDatesList());

  const handleSubmit = useCallback((dateToUse: Date): void => {
    let recentlyUsedDatesList = getRecentlyUsedDatesList();
    recentlyUsedDatesList = addToRecentlyUsedDates(recentlyUsedDatesList, dateToUse);
    setRecentlyUsedDates(recentlyUsedDatesList);
    onSubmit(dateToUse);
  }, [onSubmit]);

  return (
    <Container>
      <ContainerLeft>
          <TimeRangePicker date={date} handleSubmit={handleSubmit} />
          <RecentlyUsedDates recentlyUsedDates={recentlyUsedDates} onClick={onSubmit} />
      </ContainerLeft>

      <ContainerRight>
        <CurrentMonth selectedDate={date} onClick={handleSubmit} />
      </ContainerRight>
    </Container>
  );
};
